/**************************************************
 * Nombre:       Casilla_Funcion_Moneda_Fecha
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";
import {formatoMonedaTabla} from "../../../Utilidades/formatoMonedaTabla";
import {formatoFechaTabla} from "../../../Utilidades/formatoFechaTabla";

const Casilla_Funcion_Moneda_Fecha = ({fecha, decimales=0,dato, dir, funcion = null}) => {


    const transformar = (e) => {


        if (funcion) {

            return funcion(e);

        } else {
            return 0
        }
    }


    return (
        <TableCell key={dato} variant={'body'} align={dir}
                   sx={{color: COLORTEXTO, fontWeight: 600, fontSize: 14, minWidth: 160}}>
            <Grid container size={12} alignItems={'center'}>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 12}}>
                            {fecha ? formatoFechaTabla(fecha) : 'Sin fecha'}
                        </Typography>
                    </Grid>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 14, fontWeight: 600}}>
                            {formatoMonedaTabla(transformar(dato), decimales)}
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>

        </TableCell>
    )

}
export default Casilla_Funcion_Moneda_Fecha